import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="hidden md:block bg-brand-dark border-t border-gray-800 text-gray-400">
      <div className="w-full px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-accent flex items-center justify-center">
                <span className="text-white font-bold text-sm">CV</span>
              </div>
              <span className="text-white font-bold text-sm sm:text-base">Christian Videos</span>
            </div>
            <p className="text-xs sm:text-sm text-gray-500">
              Bringing inspirational Christian content to viewers worldwide.
            </p>
            <Link to="/about" className="inline-block mt-3 text-xs hover:text-white transition-colors">
              Learn more about us →
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm sm:text-base">Quick Links</h3>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/search" className="hover:text-white transition-colors">
                  Search
                </Link>
              </li>
              <li>
                <Link to="/watchlist" className="hover:text-white transition-colors">
                  My Watchlist
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Info */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm sm:text-base">Company</h3>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm sm:text-base">Follow Us</h3>
            <div className="flex gap-3 sm:gap-4">
              <a href="https://www.facebook.com/christianvideoalbums" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">
                <FaFacebook size={18} className="sm:w-5 sm:h-5" />
              </a>
              <a href="#" className="hover:text-blue-400 transition-colors">
                <FaTwitter size={18} className="sm:w-5 sm:h-5" />
              </a>
              <a href="#" className="hover:text-pink-400 transition-colors">
                <FaInstagram size={18} className="sm:w-5 sm:h-5" />
              </a>
              <a href="#" className="hover:text-red-600 transition-colors">
                <FaYoutube size={18} className="sm:w-5 sm:h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center text-xs sm:text-sm text-gray-500 gap-4">
            <p>&copy; 2025 Christian Videos. All rights reserved.</p>
            <div className="flex flex-wrap gap-3 sm:gap-6 justify-center sm:justify-start">
              <Link to="/privacy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="hover:text-white transition-colors">
                Terms of Service
              </Link>
              <Link to="/contact-us" className="hover:text-white transition-colors">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
